module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"service_files.section.galleries":"{label}","service_files.section.galleries.empty":"ไม่พบ {label}","service_files.section.others":"{othersLabel}","service_files.section.others.empty":"ไม่พบ {othersLabel}"}}')
  delete Component.options._Ctor
}
